jQuery(function($) {
  	 
	  var l_window = $(window).width();
	  var h_window = $(window).height();
	  var header = $('#masthead');
	  var top_sticky = 40;



    //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();

   // if(l_window < 1023){
   // 	$("#video_home").attr('poster', $("#video_home").attr('data-poster-mobile'));
   // }
	  /* ******************* */
	 /* MENU TOGGLE */
	 /* ******************* */

	 if($('body').hasClass('admin-bar')) top_sticky = parseInt(top_sticky + 32);
	   $( ".menu-toggle" ).click(function() {
	  if($(this).attr('aria-expanded') == "true"){
	      $('body').addClass('open-menu');
	  }else{
	      $('body').removeClass('open-menu');
	  }
	});


	 /* ******************* */
	 /* CLICK SUR UN SOUS-MENU DANS LA PAGE BOOSTER ? */
	 /* ******************* */
	  $('body').on('click', "#primary-menu li a", function(e) {
        
    if (!$(e.target).is('a') && !$(e.target).hasClass('_width_link')) {   // pour les imags dans les span   ///// ON AVAIT  if (!$(e.target).is('a') && !$(e.target).parent().parent().is('a')) { 
   
    }else{
          var $current_url = document.URL.split("#");
          var url_withour_anchor= $current_url[0].substring(5); // remove http: (OU HTTPS attention ! )
            // si il y a un # dans l'url et que la base de l'url est la meme
            if($(e.target).is('a')){
            if ($(e.target).attr('href').indexOf("#") != -1 && $(e.target).attr('href').indexOf(url_withour_anchor) > -1) {
                var anchor_url = $(e.target).attr('href').split("#");
                var $hash_location = $("#"+anchor_url[1]);
               if($($hash_location).length){
                var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top - header.height();
   
                   if($("body").hasClass('open-menu')){
                   		$('body').removeClass('open-menu');
                   		$('#masthead').removeClass('open');
                   		$('#site-navigation').removeClass('toggled');
                   		$( ".menu-toggle" ).attr('aria-expanded', false);
                  }

                  $('html, body').stop().animate({ 
                      scrollTop: offsetTop
                  }, 500);

                  e.preventDefault();
            }   
            }
          }
        }
    });

	/* ********************************************** */
	/* **** ACTIVATION DU BON SOUS-MENU DANS MENU PRINCIPAL ************* */
	/* ********************************************** */
			
       // Cache selectors
       var lastId,
      start_url = '',
      topMenuHeight = 180,
      // All list menuItems
      menuItems = $("#primary-menu > li > ul a"),
      // Anchors corresponding to menu items
      scrollItems = menuItems.map(function(){

        var item = $("#"+$(this).attr("href").split("#")[1]);
        start_url = $(this).attr("href").split("#")[0];
        if (item.length) {return item;}
      });


    // Bind to scroll
    $(window).scroll(function(){
     // Get container scroll position
     var fromTop = $(this).scrollTop();
    
     // Get id of current scroll item
     var cur = scrollItems.map(function(){
        variable_top = 10;
       if ($(this).offset().top - topMenuHeight - variable_top < fromTop)
       {

         return this;
       }
     });
     // Get the id of the current element
     cur = cur[cur.length-1];
     var id = cur && cur.length ? cur[0].id : "pour_quoi";
     if (lastId !== id) {
         lastId = id;
         // Set/remove active class
         menuItems.removeClass("active");
         menuItems.filter("a[href='"+start_url+"#"+id+"']").addClass("active");
     }else{
      menuItems.filter("a[href='"+start_url+"#pour_quoi']").addClass("active");
     }                 
  });


  // ** //
  // AU RECHARGEMENT OU AU SCROLL DE LA PAGE = ON FAIT SCROLL SMOOTH VERS LA POSITION // 
  // ** // 
  function scroll_good_anchor(){
     if(window.location.hash) {
      var $hash_location = window.location.hash;
      if($($hash_location).length){
         var offsetTop = $hash_location === "#" ? 0 : $($hash_location).offset().top-topMenuHeight;
          $('html, body').stop().animate({ 
              scrollTop: offsetTop
          }, 500);
      }
    } 
  }

  scroll_good_anchor();



	  /* ******************* */
	 /* FITVID - POUR VIDEO DANS LIGHTBOX  */
	 /* ******************* */

     $(".BlocContainerFullW").fitVids();


	  /* ******************* */
	 /* STICKY SCROLL */
	 /* ******************* */

	 $(window).scroll(function () {
	      action_on_scroll();
	  });

	  function action_on_scroll(){
	    l_window = parseInt($(window).width());

	       if ($(window).scrollTop() > top_sticky && l_window > 1023){
	        header.addClass("Masthead--sticky");
	        $("body").addClass('header--sticky');
	      }else{
	          header.removeClass("Masthead--sticky");
	          $("body").removeClass('header--sticky');
	      }
	  }


	 /* ******************* */
	 /* LIGBOX PAGE BOOSTER */
	 /* ******************* */
	$('a[href="#altheora-lightbox"]').append('<span class="tooltiptext">En savoir <i class="icon-plus"></i></span>');
  	$('a[href="#altheora-lightbox"]').featherlight(
      $("#altheora-lightbox"),
    	{
    	otherClose:'a.closelightbox',
    	type : "html",
  	  });

  	/* ******************* */
	 /* LIGBOX VIDEO JURY BOOSTER */
	 /* ******************* */
	 	$('a.link_lightbox_video_jury').featherlight(
	    //  $($(this).attr('href')),
	    {
	   // type : "html",
	    otherClose:'a.closelightbox',
	    beforeOpen:function(event){
			$('.featherlight').addClass('featherlight--specialVideoBg');
			//$('.featherlight').addClass('featherlight--specialVideoBg');
	 }, afterContent : function(event){
	    		
	    	$(".BlocVideoJury").fitVids();
	    	// CF MECELEC comme exemple
			// if(!document.querySelector("#youtube_script")){
			// 	// 2. This code loads the IFrame Player API code asynchronously.
		 //      var tag = document.createElement('script');
		 //      tag.id = 'youtube_script';

		 //      tag.src = "https://www.youtube.com/iframe_api";
		 //      var firstScriptTag = document.getElementsByTagName('script')[0];
		 //      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		 //  	}
			}
	  });

	
	/* ******************* */
	 /* LIGBOX VIDEO HOME PAGE */
	 /* ******************* */
	 	$('a.btn_link_video').featherlight(
	    //  $($(this).attr('href')),
	    {
	    otherClose:'a.closelightbox',
	    beforeOpen:function(event){
			$('.featherlight').addClass('featherlight--specialVideoBg');
			//$('.featherlight').addClass('featherlight--specialVideoBg');
	 }, afterContent : function(event){
	    		
	    	$(".videoContainerHome").fitVids();

			}
	  });  

	 /* ******************* */
	 /* BACK TOP TOP  */
	 /* ******************* */
	 $('.btn_back_to_top').hide();
	$(window).scroll(function() {
	    if ($(this).scrollTop() > 500) {
	        $('.btn_back_to_top').fadeIn();
	    } else {
	        $('.btn_back_to_top').fadeOut();
	    }
	});

	$(".btn_back_to_top").click(function() {
	    $("html, body").animate({scrollTop: 0}, 1000);
	 });


	/* ******************* */
	/* ******************* */
	/* ******************* */
	/* ******************* */
	/* ******************* */
		/* FORMULAIRE POUR CANDIDATER   */
	/* ******************* */
	/* ******************* */
	/* ******************* */
	/* ******************* */
	/* ******************* */
	/* ******************* */

var other_society = $('.append_other_txt');
other_society.hide();
 $('#secteur_autre').change(function() {
   if($(this).is(":checked")) {
      other_society.fadeIn(400);
      return;
   }
   other_society.fadeOut(400);
   //'unchecked' event code
});


 /* ******************* */
 /* POUR FOCUS SUR  GRAND CHAMP TXT  */
 /* ******************* */
    $( ".form-candidate label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".form-candidate p.to_child_move  input[type='text']" ).focus(function() {
      $( this ).parent().addClass('focus');
  });



/********************************/
/***** UPLOAD DOCUMENT AVEC UPLOAD Ajax-ABCI ******/
/***** SEULEMENT CONFIGURATION. L'INIT EST FAITE APRES L'ETAPE 1 ******/
/*********************************/

var global_file_tab = [];
var global_file_simple_name = [];
var $system_upolad_init = false;

// Destination ajax de l'upload
var destination_ajax = site_value.themeurl+'/Upload-Ajax-ABCI/Php_Upload/UploadAjaxABCI_Upload_Custom_Boosters.php';

var form = $("#form_custom");
var infos_form = form.find(".infos_form");

var Up = new UploadAjaxABCI(destination_ajax, form, infos_form);

// Si vous faites un contrôle des extensions (recommandé), vous devez refaire ce même contrôle côté serveur par sécurité.
var file_form = form.find('input[type=file]');
Up.config.filesExtensions = file_form.attr('accept') != undefined ? file_form.attr('accept').split(',') : [];

Up.config.ajaxTimeOut = 250; // 250 normalement //



// Taille maximale autorisée. Mettre la ligne ci-dessous en commentaire pour vérifier le controle de la taille maximale côté serveur
Up.config.fileSizeMax = file_form.attr('data-max-size') != undefined ? file_form.attr('data-max-size') : null;


// Il conviendrait peut-être de baisser (ou mettre à zéro) la valeur ci-dessous pour les smartphones.
Up.config.imgPreviewMaxSizeTotal = 0; // en Mo poids total maximum de toutes les photos. Au delà les vignettes ne seront pas affichées.


// Option pour indiquer un élément html en remplacement du bouton de sélection des fichiers par défaut du navigateur.
Up.config.customFileSelect = ".bouton_custom_file";

// Durant le téléchargement des fichiers, applique ces effets sur le bouton d'envoi du formulaire.
Up.config.cssSubmitOn = "cursor:wait;opacity:0.4";

// Durant le téléchargement des fichiers, applique ces effets le bouton de sélection des fichiers.
Up.config.cssFileSelectOn = "cursor:wait;opacity:0.7;color:#222";

/* Il s'agit d'une boite spécifiquement dédiée à l'upload, j'interdis donc la soumission du formulaire si aucun fichier n'est soumis. 
Economise une requête inutile si tous les fichiers sélectionnés ont été arrêtés avant l'envoi et que le formulaire est néanmoins soumis. 
Voir "config.submitWithoutFileFuncFormEnd" à la ligne suivante qui indispensable dans cet exemple.
*/
Up.config.submitWithoutFile = false;

/* Si Upload.config.submitWithoutFile = false, l'option ci-dessous (cf mode d'emploi) permet néanmoins le déclenchement de la méthode événementielle "config.func_FormEnd" 
dont j'ai besoin pour afficher le récapitulatif en fin de traitement du formulaire.
*/
Up.config.submitWithoutFileFuncFormEnd = true;


// Modification des messages par défaut de la classe javascript
Up.info.status.inProgress = '<span style="color:green;font-style:italic">&nbsp;en cours...</span>';
Up.info.status.stop = 'arrêt';
/* Modification de la réponse textuelle du status si téléchargement ok. En mettant vide seules les informations envoyées par php en retour de requête ajax seront affichées. 
C'est le rond vert défini avec la classe "symbol_result" qui témoignera du status ok.
*/
Up.info.status.ok = ""; 

// Définitions de variables nécessaires au script. 
var content = form.find(".content"),
custom_select = form.find(Up.config.customFileSelect),
custom_select_texte = custom_select.text(),
custom_select_remplacement = "Traitement en cours...",
fermer_formulaire = $(),
slideUp = function(){content.slideUp(400);};

 
// Définition d'une méthode javascript événementielle "config.func_FileSelectAll" qui sera exécutée à la sélection des fichiers.
Up.config.func_FileSelectAll = function(event,tableau)
{
	// console.log(tableau);
	
	// Le bouton de fermeture servira plus loin et dans les fonctions suivantes
	fermer_formulaire = form.find(".fermer_formulaire");

	// Je ferme l'éventuel message sur la sauvegarde (si plusieurs soumissions du formulaire)
   	content.find(".backupend").css('display','none');

	// slide de fermeture (slideUp) onclick sur le bouton de fermeture
	fermer_formulaire.one("click", slideUp);
	
	// Je ferme la boite au cas où elle serait ouverte (si soumission multiples) puis je l'ouvre
	content.css('display','none').slideDown();
};


// Définition d'une méthode javascript événementielle qui sera exécutée à la soumission du formulaire (option ".config.func_FormSubmit")
Up.config.func_FormSubmit = function()
{
	// Durant l'upload je supprime la possibilité de fermeture pour que le visiteur puisse toujours voir les informations
   fermer_formulaire.off("click");
   
   // Je change le contenu de l'entête (.bouton_custom_file) en mettant "Traitement en cours..."
   custom_select.text(custom_select_remplacement);
};

Up.config.func_FileEndEach = function(objet, info_serveur, mixte_serveur){
    if(mixte_serveur != undefined) 
	{	
		/* Je passe par un objet intermédiare pour transformer le tableau des options sélectionnées en une chaine de caractères avec les options séparées par une virgule. 
			Si les champs n'ont pas été renseignés je leur affecte la valeur 'null'
		*/

		var toJson = JSON.stringify(mixte_serveur);
		
		///// LA ICI CHARGEMENT FICHIER 
		if(!global_file_simple_name.includes(mixte_serveur.nom_original_fichier)) {
			global_file_simple_name.push(mixte_serveur.nom_original_fichier);
			global_file_tab.push(mixte_serveur.nom_final_fichier);

			// PODOM PM
			var to_string_add = '';
			to_string_add += '<li><span>'+mixte_serveur.nom_original_fichier+'</span></li>';

			if($('#list_file_upload_def').hasClass('aucun')){
				$('#list_file_upload_def').removeClass('aucun').addClass('widthfile').html('');
			}
			$('#list_file_upload_def').append(to_string_add);

		} 
		
	}
		

};


// Définition d'une méthode javascript événementielle qui sera exécutée à la fin du traitement du formulaire (option ".config.func_FormEnd")  
Up.config.func_FormEnd = function(tableau,info_serveur, mixte_serveur)
{ 

	/* L'upload terminé je remet le comportement de fermeture sur le bouton de fermeture et sur le bouton d'information "Traitement terminé" défini dans le html 
	avec ".fin_traitement"
   	*/
	$.each([form.find(".fin_traitement"), fermer_formulaire], function()
	{
		$(this).one("click", slideUp);
	}); 
	
   	// Je remet le texte initial 
   	custom_select.text(custom_select_texte);
	
	/* Je compte le nombre de fichiers entièrement téléchargés ainsi que les fichiers traités et l'existence d'une sauvegarde, en utilisant des propriétés des objets 
	(cf doc : "Options de la classe Javascript -> Contenu des objets spécifiques à chaque fichier"). 
	Décommenter console.log(tableau) pour voir le contenu des tableaux dans la console du navigateur.
	*/
	//console.log(tableau);

	var ok = 0;
	var traite = 0;
	var sav = 0;

	var save_real_file_tab = [];

	$.each(tableau, function(i,v)
	{	
		if(v.result == 'ok_done'){
			ok++;

			// ON PEUT RECUPERER LES NOMS DES FICHIERS ICI 
			
			//console.log.v.fichier
			
		}
		else if(v.result != '0_0'){
			traite++;
		}
		
		/* Le préfixe "backup" indique l'existence d'une sauvegarde et le suffixe "done" ou "fail" indique l'état de la requête. 
		Pour un gros fichier qui nécessite plusieurs requêtes, une requête pourrait être défectueuse mais le fichier pourrait néanmoins avoir une sauvegarde 
		réalisée lors des précédentes requêtes. Il faut donc tester ces deux résultats pour vérifier la présence d'une sauvegarde créée par le serveur.
		*/
		if(v.result == 'backup_done' || v.result == 'backup_fail'){
			sav++;
		}
		
		/*
		Notez que la propriété "result" n'est renseigné qu'au retour de la requête serveur sinon sa valeur est '0_0'. Si je voulais tester l'existence d'une sauvegarde 
		même si le fichier n'a pas été transmis au serveur, je pourrais tester la propriété "qte_save" qui est renseignée en continu, y compris dès la sélection du 
		fichier si celui-ci dispose d'une sauvegarde précédente. Je pourrais donc faire :
		
		if(v.qte_save > 0){
			sav++
		}
		
		Mais dans cet exemple c'est redondant. D'une part parceque s'il on arrête le fichier avant l'envoi c'est que l'on ne veut pas le télécharger, 
		et d'autre part ce message a déjà été affiché précédemment lors de la création de la sauvegarde.	
		*/
	});

	/*
	Pour avoir le nombre de fichiers sélectionnés qui n'ont pas été téléchargés avec succès on pourrait faire (cela regroupe les fichiers en erreur, 
	ou arrêtés en cours d'upload ou arrêtés avant l'upload) :
	var fichiers_non_ok = tableau.length - ok;
	*/
	
	// Cible dans laquelle on affiche l'information
	var info_server = form.find(".UpAbci_infosServer");
	
	switch(ok)
	{
		/* Aucun fichier sélectionné n'a été soumis car erreur d'extension ou de taille (si vous avez configuré ces options), ou encore les fichiers ont été 
		arrêtés avant l'envoi du formulaire.
		*/
		case 0 : if(traite == 0) {info_server.html('Aucun fichier traité');}break;
		case 1 : info_server.html(ok+' '+'fichier téléchargé');break;
		// test sur ok > 1 dans la case "default", car un fichier peut être en erreur côté serveur et dans ce cas il n'est pas téléchargé avec succès.
		default : if(ok > 1) {info_server.html(ok+' '+'fichiers téléchargés');}
	}

	// Je fais afficher le bloc
	info_server.css({'display':'block'});

	if(sav > 0)
	{
		// Slide sur l'information de sauvegarde
		content.find(".backupend").slideDown(300);
	}
};


// PDOOM HERE 



/********************************/
/***** FCT POUR FORMULAIRE ******/
/*********************************/

function isObjEmpty(obj) {
  return Object.keys(obj).length === 0;
}

  //this submit part need to be move to the recaptacha validation script after succeed.


  var ToDisplayMessage_form = $('.InfoMessage'), $InfoMessage_Part1 = $('.InfoMessage-Part1'),$InfoMessage_Part2 = $('.InfoMessage-Part2'), msg_info, info_pos_scroll_top = 0, class_msg_info;
  var $MessageInfondaNotGenerate = $('p.observation_disable');
  var $all_loader_form = $('.loader_form');
  var $button_generate_form = $("#button-generate_form");
  var $button_finalisation_form = $("#button-finalisation_form");
  ToDisplayMessage_form.hide();


  /**********************************/
  /**********************************/
/* Fonction executé juste_apres la génération du NDA pour débloquer les prochaines étapes*/
function unlock_next_step(){
	$('.FieldsetDisable').removeAttr('disabled').removeClass('FieldsetDisable');
	$MessageInfondaNotGenerate.slideUp(500);
}

function reset_form(){
	$(".FieldSetNumber input[type=text],.FieldSetNumber input[type=email], .FieldSetNumber textarea").val("");
	$('.FieldSetNumber input:checkbox').removeAttr('checked');
	$('#list_file_upload_def').removeClass('widthfile').addClass('aucun').html('<li>Aucun fichier uploadé.</li>');
	$button_generate_form.attr('disabled', false);
	$MessageInfondaNotGenerate.slideDown(500);
	$('.FD-S').addClass('FieldsetDisable').attr('disabled', 'disabled');
	global_file_tab = [];
    global_file_simple_name = [];
}
 
 /********************************/
/***** ACTIONS POUR FORMULAIRE ******/
/*********************************/

  $( ".btn-activ-form" ).click(function(e) {
    e.preventDefault();
    
    $all_loader_form.addClass('visible').fadeIn(200);
    var step_formulaire = $(this).attr('data-step');

    var This_new_form = $("#js-form-candidate");

    var action_this_form = 'form_candidature_boosters';

    /***** GOOGLE RECAPTCHA ******/
      grecaptcha.execute(site_value.sitekey_ggrecaptcha, {action: action_this_form}).then(function(token) {
      document.getElementById('form_candidature_token').value=token;
      var formData = This_new_form.serialize();
     
        // AJAX POUR VERIFIER LE CAPTCHA //
         $.ajax({
              url : site_value.ajaxurl,
              method : 'POST',
              dataType: "json",
              data : {
                'action' : 'candidature_boosters',
                form_data : formData,
                step_form: step_formulaire,
                security: $('#security_candidature_form').val(),
                fichier_candidature_upload: global_file_tab,
                commentaire_fichier:$('#commentaire_fichier').val()
            }
          }).done(function(response) {
            
 
            $all_loader_form.fadeOut(200).removeClass('visible');

            ToDisplayMessage_form.html('').slideUp(500).removeClass('msg-error msg-validate');

            // 1.0 Si erreur précedente, on doit cacher les messages d'infos 
	        $('.only_for_error').html('').removeClass('error-validation');

            // A/ ERREUR
            if(response.erreur){
            	msg_info = '<p><strong>Il y a au moins une erreur dans le formulaire.</strong></p>';
            	class_msg_info = 'msg-error';
            	info_pos_scroll_top = 0;
            }else{

            	// Pas d'errreur //
            	if(response.return_step_form == 'generation_nda'){
            		// Démarrage de la fonction d'upload
					unlock_next_step();
					if(response.name_pdf){
						var url_pdf_generate = site_value.urlbase+'/NDA_GENERATE/'+response.name_pdf;
						window.open(url_pdf_generate, '_blank');
						if(!$system_upolad_init){ Up.Start(); $system_upolad_init = true;}
						msg_info = '<p><strong>Votre demande à bien été enregistrée.</strong></p>';
            			msg_info += '<p>Votre <strong>accord de confidentialité</strong> a été généré avec succès.<p><p>Si le téléchargement automatique de l\'accord de confidentitalité à échoué, vous pouvez le <a target="_blank" href="'+url_pdf_generate+'" title="Télécharger le NDA">Télécharger ICI</a> puis poursuivre votre candidature.</p><p class="warning">Attention, votre candidature n\'est pour l\'instant pas finalisée. Merci de compléter les autres champs du formulaire puis de cliquer sur <strong>"Valider ma candidature".</strong></p>'; 	
            	    	class_msg_info = 'msg-validate';
            	    	$button_generate_form.attr('disabled', true);
            		}else{
            			response.erreur = true;
            			msg_info = '<p><strong>Erreur lors de la génération de l\'accord de confidentitalité</strong></p>';
            	    	class_msg_info = 'msg-error';
            		}
            		
            	}else if(response.return_step_form == 'finalisation_candidature'){
            		msg_info = '<p><strong>Votre demande a bien été enregistrée.</strong></p><p>Nous accusons bonne réception de votre dossier de candidature à l\'Édition 2022 des Boosters by Altheora Shift et vous remercions de votre participation.</p><p>Notre jury d’experts étudiera votre dossier jusqu’au 16 Septembre 2022 et pourra être amené à revenir vers vous aux coordonnées indiquées afin d’en savoir plus sur votre projet </p><p> Un mail de confirmation de dépôt de condidature vous a été envoyé, pensez à vérifier vos spams ! </p>';
            		class_msg_info = 'msg-validate';
            		reset_form(); // On vide tous les champs... 

            	}else{
            		response.erreur = true;
            		class_msg_info = 'msg-error';
            		msg_info = '<p><strong>Il y a un problème dans le fonctionnement du formulaire.</strong>Vous devez respecter les différentes étapes du formulaire.</p>';
            	}
            	
            }

           
          	if(response.erreur){
	          	//2.0 Si erreur, on affiche les messages d'erreurs au bon endroit dans le formulaire
	            var message_champs_olb = '';
	           	
	           	if(response.msg_error != ""){
	           		msg_info += '<p>'+response.msg_error+'</p>';
	           	}

	            if(!isObjEmpty(response.champs)){
	            	msg_info += '<p>Certains champs ne sont pas renseignés ou incorrect. <br />Merci de vérifier le(s) champ(s) : ';
		            response.champs.forEach(function(item){
		            	if(info_pos_scroll_top == 0) {info_pos_scroll_top = parseInt($('.'+item.class_add_elt).parent().offset().top - 200);}
		            	msg_info += '<strong>'+item.champ_general+'</strong>, ';
						$('.'+item.class_add_elt).html(item.message).addClass('error-validation');
					});
		            msg_info = msg_info.slice(0, -2);
					msg_info += '</p>';
	        	}

 				$('html, body').stop().animate({ 
                      scrollTop: info_pos_scroll_top
                  }, 500);
        	}

        	if(response.return_step_form == 'generation_nda'){
        		$InfoMessage_Part1.html(msg_info).addClass(class_msg_info).slideDown(500);
        		
        	}else if(response.return_step_form == 'finalisation_candidature'){
        		$InfoMessage_Part2.html(msg_info).addClass(class_msg_info).slideDown(500);
        	}else{
        		// auttre ... ggrecpatch etc.. 
        		$InfoMessage_Part1.html(msg_info).addClass(class_msg_info).slideDown(500);
				$InfoMessage_Part2.html(msg_info).addClass(class_msg_info).slideDown(500);
        	}
            // console.log(response); PODOM DEBUG //

        }).fail(function(data) {
        	// Probleme d'accès au php...
        	//console.log("fail ? "+ data);
        	console.log(JSON.stringify(data));
        	$all_loader_form.fadeOut(200).removeClass('visible');
        	msg_info = '<p>Il y a eu un problème lors de la <strong>validation du formulaire</strong>. Veuillez recommencer ou contacter un administrateur.</p>';
        	class_msg_info = 'msg-error';
        	$InfoMessage_Part1.html(msg_info).addClass(class_msg_info).slideDown(500);
			$InfoMessage_Part2.html(msg_info).addClass(class_msg_info).slideDown(500);
  
      });

    }, function (reason) {
      // ICI LE CAPTCHA QUI VEUT PAS S'EXECUTER
        $all_loader_form.fadeOut(200).removeClass('visible');
        msg_info = '<p>Il y a eu un problème lors de la <strong>validation de Google RECAPTCHA</strong>. Veuillez recommencer ou contacter un administrateur.</p>';
        class_msg_info = 'msg-error';
        $InfoMessage_Part1.html(msg_info).addClass(class_msg_info).slideDown(500);
		$InfoMessage_Part2.html(msg_info).addClass(class_msg_info).slideDown(500);
		//console.log(reason);
   });


    });

 
 }); // fin function loaded apres chargement HTML


/* ///////////////////////////////////////////
Compteur de caractère pour les textarea
////////////////////////////////////////////// 
*/

function limiting(oEvent) {
  if(isNaN(this.maxLength) == false){ 
    var oDiv =  document.getElementById(this.name+"Error");
    if(oDiv){
      var oCnt = oDiv.children[0],
          iLongueur = this.value.length,
          iLimit = this.maxLength;
      if(iLimit - iLongueur < 50) {
        oCnt.classList.add("warning");
      }else{
        oCnt.classList.remove("warning");
      }//else
      oCnt.textContent = iLongueur;
    }
  }//if
}//fct


document.addEventListener('DOMContentLoaded',function(){
  var aTextarea = document.getElementsByTagName('textarea');
  for(var oTextarea of aTextarea){
    if(oTextarea.maxLength != -1 && oTextarea.dataset.maxlength == null){
      //Avec un attribut maxlength
      oTextarea.addEventListener('input',limiting);
    }
  }
});
